import React, { useEffect, Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as ArrowFrame } from '../../assets/Group.svg';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { dateOptions } from '../../constants';
import Select from 'react-select';
import { MdDeleteForever } from 'react-icons/md';
import '../SalesTarget/salestarget.scss';
import './poptarget.scss';
import InputWithIcon from '../../components/InputWithIcon/InputWithIcon';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Toggle from 'react-toggle';
import base from '../../apis';
import Spinner from '../../components/Spinner/Spinner';
import { capitalizeFirstLetter } from '../../utils/functions';

const initialTarget = {
  title: '',
  owner: '',
  period: { label: 'Yearly', value: 'Yearly' },
  amount: '',
  amount_per_team: '',
  year: { label: new Date().getFullYear(), value: new Date().getFullYear() },
  month: {
    label: new Date().toLocaleString('en', { month: 'long' }),
    value: new Date().getMonth(),
  },
  sub_targets: [
    {
      id: null,
      package_name: null,
      selectedProduct: null,
      points_per_sub: '',
      amount: '',
      amount_per_team: '',
      percent_share: '',
      bonus: 1,
      subs_for_bonus: '',
      points_for_bonus: '',
      commission: '',
    },
  ],
};

const selectStyles = {
  container: (provided) => ({
    ...provided,
    width: '80%',
  }),
};

function PopTarget() {
  const id = useParams()['*'];
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const [teamCount, setTeamCount] = useState(0);
  const [subOptions] = useState([
    { label: 'BPO Farm', value: 'bpo-farm' },
    { label: 'BPO Premier Agent', value: 'premier-agent-website' },
    { label: 'Deal Analyzer', value: 'deal-analyzer' },
    { label: 'Combo Package', value: 'combo-package' },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    //todo handle when an non number is entered
    let urls = ['/operations/marketing_teams/count/'];
    if (id) {
      urls.push(`/operations/sales_targets/${id}/`);
    }
    setIsLoading(true);
    setTeamCount(0);
    Promise.all(urls.map((endpoint) => base.get(endpoint)))
      .then((data) => {
        const teamCount = data[0].data.team_count;
        if (teamCount === 0) {
          toast.error('No teams found, please create a team first');
          navigate('/mart-exec-teams');
          return;
        }

        setTeamCount(teamCount || 0);

        if (urls.length === 2) {
          const target = data[1].data;
          const year = new Date(target.date_due).getFullYear();
          target['year'] = { label: year, value: year };
          if (target.period === 'monthly') {
            const month = new Date(target.date_due).toLocaleString('en', { month: 'long' });
            target['month'] = { label: capitalizeFirstLetter(month), value: new Date(target.date_due).getMonth() };
          }
          target['period'] = {
            label: capitalizeFirstLetter(target.period),
            value: capitalizeFirstLetter(target.period),
          };

          target['sub_targets'] = target.sub_targets.map((sub) => {
            sub['selectedProduct'] = subOptions.find((item) => item.value === sub.package_name);
            sub['percent_share'] = sub.percent_share * 100;
            if (sub['points_per_sub']) {
              sub['points_per_sub'] = +sub['points_per_sub'];
            }
            return sub;
          });
          setTarget(target);
        }
      })
      .catch((err) => {
        toast.error('Something went wrong, please try again');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, navigate, subOptions]);

  const [target, setTarget] = useState(structuredClone(initialTarget));

  const onChangeSelectChange = (option, item) => {
    setTarget((prevState) => {
      return { ...prevState, [item]: option };
    });
  };

  const yearlyOptions = [
    {
      label: 2022,
      value: 2022,
    },
    {
      label: 2021,
      value: 2021,
    },
    {
      label: 2020,
      value: 2020,
    },
    {
      label: 2019,
      value: 2019,
    },
    {
      label: 2018,
      value: 2018,
    },
    {
      label: 2017,
      value: 2017,
    },
  ];

  const MonthlyOptions = [
    {
      label: 'January',
      value: 0,
    },
    {
      label: 'Febuary',
      value: 1,
    },
    {
      label: 'March',
      value: 2,
    },
    {
      label: 'April',
      value: 3,
    },
    {
      label: 'May',
      value: 4,
    },
    {
      label: 'June',
      value: 5,
    },
    {
      label: 'July',
      value: 6,
    },
    {
      label: 'August',
      value: 7,
    },
    {
      label: 'September',
      value: 8,
    },
    {
      label: 'October',
      value: 9,
    },
    {
      label: 'November',
      value: 10,
    },
    {
      label: 'December',
      value: 11,
    },
  ];

  const onAddNewSubTarget = () => {
    setTarget((val) => ({
      ...val,
      sub_targets: [...val.sub_targets, ...structuredClone(initialTarget.sub_targets)],
    }));
  };

  const onRemoveSubTarget = (index) => {
    if (target.sub_targets.length === 1) {
      toast.error('You need at least one sub target', { toastId: 'removeSubTarget' });
      return;
    }
    setTarget((val) => ({
      ...val,
      sub_targets: val.sub_targets.filter((item, i) => i !== index),
    }));
  };

  const onSave = () => {
    const subTargets = target.sub_targets;
    const ids = subTargets.map((item) => item?.selectedProduct?.value);
    const uniqueIds = [...new Set(ids)];

    if (subTargets.some((item) => !item?.selectedProduct?.value)) {
      toast.error('Select a product for each sub target', { toastId: 'product' });
      return;
    }
    if (ids.length !== uniqueIds.length) {
      toast.error('You cannot select 2 of the same type of subscriptions', { toastId: 'amount' });
      return;
    }
    if (subTargets.some((item) => !item.points_per_sub)) {
      toast.error('Enter number of points per sub target', { toastId: 'points' });
      return;
    }
    if (subTargets.some((item) => !item.amount)) {
      toast.error('Enter valid targeted amounts for each sub target', { toastId: 'amount' });
      return;
    }

    if (+subTargets.reduce((acc, item) => +acc + item.amount * 1, 0) !== +target.amount) {
      toast.error('Sum of targets must be equal to the total targeted amount', { toastId: 'amount' });
      return;
    }

    if (subTargets.some((item) => item.bonus === 1)) {
      const withBonus = subTargets.filter((item) => item.bonus === 1);
      if (withBonus.some((item) => !item.subs_for_bonus)) {
        toast.error('Enter number of subscription for bonus for all sub targets', { toastId: 'subs' });
        return;
      }
      if (withBonus.some((item) => !item.points_for_bonus)) {
        toast.error('Enter number of points to qualify for bonus for all sub targets', { toastId: 'points' });
        return;
      }
      if (withBonus.some((item) => !item.commission)) {
        toast.error('Enter commission for each sub target', { toastId: 'commission' });
        return;
      }
    }

    let date = new Date();
    const period = target.period.value.toLowerCase();
    let month = period === 'yearly' ? 11 : target.month.value + 1;
    let day = period === 'yearly' ? 31 : 0;

    date = new Date(target.year.value, month, day).setHours(23, 59, 59, 999);
    const body = {
      title: target.title,
      owner: target.owner,
      period,
      date_due: new Date(date).toJSON(),
      amount: +target.amount,
      amount_per_team: +target.amount_per_team,
      sub_targets: subTargets.map((sub) => {
        const subItem = {
          package_name: sub.package_name,
          amount: +sub.amount,
          amount_per_team: +sub.amount_per_team,
          points_per_sub: +sub.points_per_sub,
          percent_share: +Number(+sub.percent_share / 100).toFixed(2),
          bonus: sub.bonus,
          subs_for_bonus: +sub.subs_for_bonus || 0,
          points_for_bonus: +sub.points_for_bonus || 0,
          commission: +sub.commission || 0,
        };
        if (sub.id) {
          subItem['id'] = sub.id;
        }
        if (sub.main_target_id) {
          subItem['main_target_id'] = sub.main_target_id;
        }

        return subItem;
      }),
    };

    const post = !id
      ? base.post(`/operations/sales_targets/`, body)
      : base.put(`/operations/sales_targets/${id}/`, body);
    setIsLoading(true);
    post
      .then(() => {
        toast.success('Target saved successfully');
        //todo change to actual route
        setTimeout(() => {
          navigate(-1);
        }, 1500);
      })
      .catch((err) => {
        toast.error(`Error ${id ? 'updating' : 'creating'} target`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onChange = (e, i) => {
    const { name, value } = e.target;
    if (typeof i === 'number') {
      setTarget((prevState) => {
        const newSubTargets = prevState.sub_targets;
        switch (name) {
          case 'bonus':
            const { checked } = e.target;
            newSubTargets[i][name] = checked ? 1 : 0;
            if (!checked) {
              newSubTargets[i]['points_for_bonus'] = '';
              newSubTargets[i]['subs_for_bonus'] = '';
              newSubTargets[i]['commission'] = '';
            }
            break;
          case 'amount':
            newSubTargets[i][name] = value;
            newSubTargets[i]['amount_per_team'] = value > 0 ? (+value / teamCount).toFixed(2) : 0;
            newSubTargets[i]['percent_share'] = value > 0 ? ((+value / +prevState.amount) * 100).toFixed(2) : 0;

            break;
          case 'points_per_sub':
            if (newSubTargets[i].subs_for_bonus && newSubTargets[i].bonus) {
              //todo calculate points to qualify for bonus
              newSubTargets[i]['points_for_bonus'] = +value * +newSubTargets[i]['subs_for_bonus'];
            }
            newSubTargets[i][name] = value;
            break;
          case 'subs_for_bonus':
            if (newSubTargets[i].bonus && newSubTargets[i].points_per_sub) {
              //todo calculate points to qualify for bonus
              newSubTargets[i]['points_for_bonus'] = +value * +newSubTargets[i]['points_per_sub'];
            }

            newSubTargets[i][name] = value;
            break;

          default:
            newSubTargets[i][name] = value;
            break;
        }

        return { ...prevState, sub_targets: newSubTargets };
      });

      return;
    }
    setTarget((prevState) => {
      if (name === 'amount') {
        const newSubTargets = prevState.sub_targets;
        const toReturn = {
          ...prevState,
          [name]: value,
          sub_targets: newSubTargets.map((item) => ({ ...item, amount: 0, amount_per_team: 0, percent_share: 0 })),
        };
        if (teamCount > 0) {
          toReturn['amount_per_team'] = (+value / teamCount).toFixed(2);
        }

        return toReturn;
      }
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const validateInputs = (e) => {
    //todo do validation
    e.preventDefault();

    const check = ['title', 'owner', 'amount', 'amount_per_team'];
    for (let i = 0; i < check.length; i++) {
      if (!target[check[i]]) {
        toast.error(`Target ${check[i].split('_').join(' ')} is required`);
        document.getElementsByName(check[i])[0].focus();
        return;
      }
    }
    setPageNumber(2);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <div className="sales_target">
        {pageNumber === 1 ? (
          <form>
            {' '}
            <div className="form_row">
              <ArrowFrame className="arrow_frame" />
              <div className="sales_info">
                <p className="form_name">Target Name</p>
                <p className="formfield_details">
                  This is can be broken down into the BPO Products (ie. BPO Farm, BPO Premier and BPO Deal Analyzer)
                </p>
                <Input
                  className="input"
                  placeholder="Target Name"
                  required
                  value={target.title}
                  name="title"
                  onChange={onChange}
                  style={{
                    fontSize: '16px',
                    padding: '10px 0px',
                    marginRight: '10px',
                    border: 'none',
                    borderRadius: '0px',
                    borderBottom: '1px solid #1378A5',
                    width: '60%',
                  }}
                />
              </div>
            </div>
            <div className="form_row">
              <ArrowFrame className="arrow_frame" />
              <div className="sales_info">
                <p className="form_name">Owner</p>
                <p className="formfield_details">This is optional. Who is responsible for this target.</p>
                <Input
                  className="input"
                  placeholder="Owner"
                  required
                  value={target.owner}
                  name="owner"
                  onChange={onChange}
                  style={{
                    fontSize: '16px',
                    padding: '10px 0px',
                    marginRight: '10px',
                    border: 'none',
                    borderRadius: '0px',
                    borderBottom: '1px solid #1378A5',
                  }}
                />
              </div>
            </div>
            <div className="form_row">
              <div className="form_section">
                <ArrowFrame className="arrow_frame" />
                <div className="sales_info">
                  <p className="form_name">Target Period</p>
                  <Select
                    options={dateOptions}
                    value={target.period}
                    onChange={(option) => {
                      onChangeSelectChange(option, 'period');
                    }}
                    isSearchable={false}
                    required
                  />
                </div>
              </div>
              <div className="form_section">
                <ArrowFrame className="arrow_frame" />
                <div className="sales_info">
                  <p className="form_name">Date</p>
                  <div className={`${true ? 'date_forms' : ''}`}>
                    <Select
                      className="select"
                      options={yearlyOptions}
                      placeholder="Yearly"
                      value={target.year}
                      onChange={(option) => {
                        onChangeSelectChange(option, 'year');
                      }}
                      isSearchable={false}
                    />
                    {target.period?.value === 'Monthly' && (
                      <Select
                        className="select"
                        options={MonthlyOptions}
                        placeholder="Monthly"
                        value={target.month}
                        onChange={(option) => {
                          onChangeSelectChange(option, 'month');
                        }}
                        inSearchable={false}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form_row">
              <div style={{ flex: 1, display: 'flex' }}>
                <ArrowFrame className="arrow_frame" />
                <div className="sales_info">
                  <p className="form_name" style={{ marginBottom: '20px' }}>
                    Target Amount
                  </p>
                  <InputWithIcon
                    type="number"
                    min="1"
                    step="100"
                    required
                    value={target.amount}
                    name="amount"
                    onChange={onChange}
                    styles={{ width: '60%' }}
                    placeholderText="$ 0.00">
                    <b style={{ color: 'var(--primary-color)' }}>USD</b>
                  </InputWithIcon>
                </div>
              </div>
              <div style={{ flex: 1, display: 'flex' }}>
                <ArrowFrame className="arrow_frame" />
                <div className="sales_info">
                  <p className="form_name" style={{ marginBottom: '20px' }}>
                    Target Amount Per Team
                  </p>
                  <InputWithIcon
                    required
                    type="number"
                    min="1"
                    step="100"
                    value={target.amount_per_team}
                    name="amount_per_team"
                    disabled
                    onChange={onChange}
                    styles={{ width: '50%' }}
                    style={{ width: '80%' }}
                    placeholderText="$ 0.00">
                    <b style={{ color: 'var(--primary-color)' }}>USD</b>
                  </InputWithIcon>
                </div>
              </div>
            </div>
            <div className="form_row">
              <div className="sales_info">
                <div className="save_button_container">
                  <Button
                    type="submit"
                    onClick={validateInputs}
                    style={{
                      width: 'fit-content',
                      height: '45px',
                      fontSize: '16px',
                      padding: '10px 20px',
                      color: 'white',
                      backgroundColor: 'var(--primary-color)',
                      display: 'block',
                      marginTop: '5px',
                    }}
                    text="Save & Continue"
                  />
                </div>
              </div>
            </div>
          </form>
        ) : (
          <>
            <div className="third_form_state">
              <div className="header_info_wrapper">
                <p className="header_info">
                  <span className="previous_form" onClick={() => setPageNumber(1)}>
                    {target.year.label}
                  </span>
                  <span>{'>'}</span> {target.period.label}
                </p>
              </div>

              {target.sub_targets.map((details, i) => (
                <Fragment key={i}>
                  <div>
                    <div className="form_section">
                      <div className="rowed" style={{ position: 'relative', alignItems: 'center', gap: '20px' }}>
                        <Select
                          options={subOptions}
                          onChange={(option) => {
                            setTarget((prevState) => {
                              const subs = prevState.sub_targets;
                              subs[i].package_name = option.value;
                              subs[i].selectedProduct = option;
                              return { ...prevState, sub_targets: subs };
                            });
                          }}
                          value={target.sub_targets[i].selectedProduct}
                          placeholder="Select Subscription Type"
                          isSearchable={false}
                          id={`sub${i}`}
                          styles={selectStyles}
                          required
                        />
                        <MdDeleteForever
                          onClick={() => onRemoveSubTarget(i)}
                          title="Delete Sub target"
                          className="bin"
                        />
                      </div>
                    </div>
                    <div className="form_field">
                      <div className="form_column">
                        <p>Number of Points Per Subscription</p>
                        <div className="form_row">
                          <InputWithIcon
                            type="number"
                            min="1"
                            step="1"
                            value={target.sub_targets[i].points_per_sub}
                            name="points_per_sub"
                            onChange={(e) => onChange(e, i)}
                            required
                            styles={{ width: '50%' }}
                            placeholderText="1"
                          />
                          <p>Points/Subscription</p>
                        </div>
                      </div>
                      <div className="form_column">
                        <p>Targeted Amount</p>
                        <div className="form_row">
                          <InputWithIcon
                            type="number"
                            min="1"
                            step="100"
                            required
                            max={target.amount || 0}
                            value={target.sub_targets[i].amount}
                            name="amount"
                            onChange={(e) => onChange(e, i)}
                            styles={{ width: '60%' }}
                            placeholderText="$ 0.00"
                          />
                          <p>$</p>
                        </div>
                      </div>
                      <div className="form_column">
                        <p>Amount Per Team</p>
                        <div className="form_row">
                          <InputWithIcon
                            type="number"
                            min="1"
                            step="100"
                            value={target.sub_targets[i].amount_per_team}
                            onChange={(e) => onChange(e, i)}
                            name="amount_per_team"
                            required
                            disabled
                            styles={{ width: '60%' }}
                            placeholderText="$ 0.00"
                          />
                          <p>/Team</p>
                        </div>
                      </div>
                    </div>
                    <div className="form_field">
                      <div className="form_column">
                        <p className="marginer">Percentage Share</p>
                        <span className="small">The percentage the subtarget covers</span>
                        <div className="form_row">
                          <InputWithIcon
                            type="number"
                            min="1"
                            step="100"
                            max="100"
                            required
                            value={target.sub_targets[i].percent_share}
                            name="percent_share"
                            onChange={(e) => onChange(e, i)}
                            styles={{ width: '20%' }}
                            disabled
                            placeholderText="$ 0.00"
                          />

                          <p>%</p>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>
                      <span>Bonus</span>
                      <Toggle
                        icons={false}
                        className="toggler"
                        checked={target.sub_targets[i].bonus === 1}
                        name="bonus"
                        onChange={(e) => onChange(e, i)}
                      />
                    </div>
                    {target.sub_targets[i].bonus === 1 && (
                      <div className="form_field">
                        <div className="form_column">
                          <p className="marginer">Qualification</p>
                          <p className="small">Number of subscription to qualify for a bonus</p>
                          <div className="form_row">
                            <InputWithIcon
                              type="number"
                              min="1"
                              step="100"
                              style={{ width: '100%' }}
                              value={target.sub_targets[i].subs_for_bonus}
                              name="subs_for_bonus"
                              onChange={(e) => onChange(e, i)}
                              required
                              styles={{ width: '60%' }}
                              placeholderText="1"
                            />
                            <p>Subscriptions</p>
                          </div>
                        </div>
                        <div className="form_column">
                          <p className="marginer">Points </p>
                          <p className="small">Number of points to qualify for a bonus</p>
                          <div className="form_row">
                            <InputWithIcon
                              type="number"
                              min="1"
                              step="100"
                              required
                              disabled
                              style={{ width: '100%' }}
                              value={target.sub_targets[i].points_for_bonus}
                              name="points_for_bonus"
                              onChange={(e) => onChange(e, i)}
                              styles={{ width: '40%' }}
                              placeholderText="1"
                            />
                            <p>Points</p>
                          </div>
                        </div>
                        <div className="form_column">
                          <p className="marginer">Commission </p>
                          <p className="small">How much does a bonus attract?</p>
                          <div className="form_row">
                            <InputWithIcon
                              type="number"
                              min="1"
                              step="100"
                              value={target.sub_targets[i].commission}
                              onChange={(e) => onChange(e, i)}
                              name="commission"
                              required
                              styles={{ width: '60%' }}
                              placeholderText="$ 0.00"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <hr className="ruler" />
                </Fragment>
              ))}

              <div className="form_field">
                <div className="form_column">
                  <Button
                    type="submit"
                    style={{
                      textAlign: 'left',
                      border: 'none',
                      width: '80%',
                      height: '45px',
                      fontSize: '16px',
                      padding: '10px 20px',
                      color: 'white',
                      backgroundColor: '#1378A5',
                      display: 'block',
                      marginTop: '5px',
                    }}
                    onClick={onAddNewSubTarget}
                    text="New Sub Target"
                  />
                </div>
              </div>
              <div className="save_btn_wrapper">
                <Button
                  type="submit"
                  onClick={() => setPageNumber(1)}
                  style={{
                    width: 'fit-content',
                    height: '45px',
                    fontSize: '16px',
                    padding: '10px 20px',
                    color: 'white',
                    backgroundColor: 'var(--primary-color)',
                    display: 'block',
                    marginTop: '5px',
                    marginRight: '10px',
                  }}
                  text="Back"
                />
                <Button
                  className="save"
                  type="submit"
                  style={{
                    borderRadius: '5px',

                    textAlign: 'left',
                    width: 'fit-content',
                    height: '45px',
                    fontSize: '16px',
                    padding: '10px 20px',
                    backgroundColor: 'white',
                    color: '#1378A5',
                    border: '1px solid #1378A5',
                    display: 'block',
                    marginTop: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={onSave}
                  text="Save"
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default PopTarget;
